import React from 'react';
import {connect} from 'react-redux';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import {setSelectedSchedule} from "../../actions/join/joinActions";
import {translate} from '../../i18n/translate.js';
import {getUsefulDate} from "../../common/utils";

class JoinScheduleSelector extends React.Component {
    onChangeSchedule = (eventKey) => {
        this.props.setSelectedSchedule(this.props.item.key, eventKey);
    };

    //Sort the menu items first by the number of deliveries and then alphabetically
    sortSchedules = (schedule1, schedule2) => {
        if (schedule1.props.scheduleweeksleft === schedule2.props.scheduleweeksleft) {
            return schedule1.props.scheduletitle.localeCompare(schedule2.props.scheduletitle);
        }
        return schedule2.props.scheduleweeksleft - schedule1.props.scheduleweeksleft;
    };

    render() {
        const allSchedules = this.props.schedules || {};
        let itemSchedules = this.props.item.schedules;
        const distributions = this.props.item.weeksLeft[0];
        if(itemSchedules.length === 0) {
            return null;
        }else if(itemSchedules.length === 1) {
            if(this.props.isFarmSeasonal && distributions && distributions > 1)
                return (<div className="item-distributions">{this.props.item.weeksLeft[0] + " " + translate("Distributions")}</div>);
            else
                return null;
        }else {
            let title = translate("Select schedule");
            if (this.props.item.selectedSchedule){
                title = allSchedules[this.props.item.selectedSchedule].title;
                let distributionsNumber = 0;
                itemSchedules.map((schedule, index) => {
                    if (this.props.item.selectedSchedule === schedule)
                        distributionsNumber = this.props.item.weeksLeft[index];
                });
                if (this.props.isFarmSeasonal && distributionsNumber > 1)
                    title += ' (' + distributionsNumber +" "+ translate("Distributions")+')';
            }
            if (this.props.item.quantity > 0)
                return <div className="item-distributions">{title}</div>;
            const scheduleAddBtnMessage = (this.props.clientViewPort && this.props.clientViewPort.isXs) ? 'Click \'+\' button to subscribe' : 'Click \'Add\' to subscribe';
            return (
                <div>
                    <DropdownButton name="btnItemSchedule" className="item-schedule" title={title} onSelect={this.onChangeSchedule} id={"schedule-"+this.props.item.key}>
                        {itemSchedules.map((schedule, index) => {
                                const distributionsNumber = this.props.item.weeksLeft[index];
                                const nextDeliveryDateText = allSchedules[schedule].nextDeliveryDate ? (' - ' + translate('starts on')+ ' ' + getUsefulDate(allSchedules[schedule].nextDeliveryDate)) : '';
                                return <MenuItem eventKey={schedule} scheduletitle={allSchedules[schedule].title} scheduleweeksleft={distributionsNumber}
                                                 key={index}>{allSchedules[schedule].title} {this.props.isFarmSeasonal && distributionsNumber > 1 ? '(' + distributionsNumber + " " + translate("Distributions") + ')' : ''}{nextDeliveryDateText}</MenuItem>
                        }).sort(this.sortSchedules)}
                    </DropdownButton>
                        {this.props.item.selectedSchedule ?
                        <div className="item-schedule-add-message">{scheduleAddBtnMessage}</div>
                        : undefined
                    }
                </div>
            )
        }
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedSchedule: (itemKey, scheduleKey) =>{
            dispatch(setSelectedSchedule(itemKey, scheduleKey));
        }
    }
};
export default connect(null, mapDispatchToProps)(JoinScheduleSelector);


// WEBPACK FOOTER //
// ./src/containers/join/JoinScheduleSelector.js